<template>
  <nav>
    <router-link :key="page.title" v-for="page in pages" :to="{ name: page.name }">
      {{ page.title }}
    </router-link>
  </nav>
</template>

<style scoped>
.nav {
  display: flex;
}

a {
  margin-right: 20px;
  border: 1px solid #ddd;
  text-decoration: none;
  padding: 10px;
  border-radius: 10px;
  color: rgb(255, 255, 255);
}
</style>

<script>
export default {
  data () {
    return {
      pages: [
        { name: 'About', title: 'About' },
        { name: 'FAQ', title: 'FAQ' },
        { name: 'How They Work', title: 'How They Work' },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue